import { Component, OnInit } from '@angular/core';

const SUPPORT_CENTER_URL = 'https://resources.rarediseases.info.nih.gov/Resources/s/';

@Component({
    selector: 'app-support-center-redirect',
    template: '',
})
export class SupportCenterRedirectComponent implements OnInit {
    ngOnInit(): void {
        window.location.replace(SUPPORT_CENTER_URL);
    }
}
